import update from 'immutability-helper';
import { createCase, createSwitch } from 'helpers/action-helpers';
import {
  ProcessingUserAction,
  SetUserProfileErrorMessageAction,
  SetUserProfileAction,
  LoadUserProfileAction
} from './actions';
import { initialState } from './state';
import { User } from 'types/user';

export const userProfileReducer = createSwitch(initialState, [
  createCase(new SetUserProfileAction({} as User), (state, action) => {
    return update(state, {
      user: { $set: action.user },
      errorMessage: { $set: '' },
      isProcessing: { $set: false },
      isLoadingProfileInfo: { $set: false }
    });
  }),
  createCase(new ProcessingUserAction(), (state) => {
    return update(state, {
      isProcessing: { $set: true }
    });
  }),
  createCase(new LoadUserProfileAction(), (state) => {
    return update(state, {
      isLoadingProfileInfo: { $set: true }
    });
  }),
  createCase(new SetUserProfileErrorMessageAction(''), (state, action) => {
    return update(state, {
      errorMessage: { $set: action.errorMessage },
      isProcessing: { $set: false },
      isLoadingProfileInfo: { $set: false }
    });
  })
]);


// WEBPACK FOOTER //
// ./src/pages/user-profile/reducer.ts